export const environment = {
    production: true,
    envName: 'test1',
    baseUrl: 'https://emdm-ui-test-dr.azure.chevron.com',
    apiUrl: 'https://emdm-api-test1-dr.azure.chevron.com/api/', //Change to test api url
    calSettings: {
        "autoSignIn": true,
        "popupForLogin": false,
        "cacheLocation": "localStorage",
        "instance": "https://login.microsoftonline.com/",
        "tenantId": "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
        "clientId": "ad6636c0-2e92-4d33-9959-4992e7c7574a",
        "redirectUri": "https://emdm-ui-test-dr.azure.chevron.com",
        "oidcScopes": ["https://emdm-test.azure.chevron.com/EMDMReadWrite"],
        "graphScopes": []
    }
  };
  